import Vue from 'vue';
import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';
import { User, MangoPayUser } from '@/store/profile/types';

const isLocal = window.location.origin.includes('http://localhost');
const environment = process.env.VUE_APP_NODE_ENV || null;

export function configSentry() {
  // configure Sentry
  // allow error tracking in staging / prod
  if (!isLocal && environment) {
    Sentry.init({
      dsn: 'https://fdd42fabf620498eb709e94443dc2220@o38895.ingest.sentry.io/5337949',
      integrations: [new VueIntegration({Vue, attachProps: true, logErrors: true})],
      environment,
    });
  }
}


export function identifySentryUser(user:User, mangoUser: MangoPayUser){
  if (!isLocal && environment) {
    // Capture user
    // https://docs.sentry.io/enriching-error-data/additional-data/?platform=javascript#capturing-the-user
    Sentry.setUser({
      id: String(user.ext_user_id),
    });

    // Set user aditional information, as well as tags and further extras
    // https://docs.sentry.io/enriching-error-data/additional-data/?platform=javascript#custom-data
    Sentry.configureScope((scope) => {
      scope.setExtra('ext_user_id', String(user.ext_user_id));
      scope.setExtra('emoney_id', String(user.id));
      scope.setExtra('mangopay_user_id', String(user.mangopay_user_id));
      scope.setExtra('mangopay_wallet_id', String(user.mangopay_wallet_id));
      scope.setExtra('kyc', JSON.stringify({
        kyc_doc_id: user.kyc_doc_id,
        kyc_doc_status: user.kyc_doc_status,
        kyc_attempt_no: user.kyc_attempt_no,
        kyc_completed_at: user.kyc_completed_at,
      }));
    });
  }
}